import { MessageBox } from 'element-ui'
import router from '@/router'

export const STORAGE_QUOTA_CODE = 413

/**
 * @param {object} payload API 响应体或 data 字段
 * @returns {boolean}
 */
export function isStorageQuotaPayload(payload) {
  if (!payload || typeof payload !== 'object') return false
  const data = payload.data && typeof payload.data === 'object' ? payload.data : payload
  return !!(data.storageQuotaExceeded || payload.storageQuotaExceeded)
}

/**
 * @param {Error|object} error axios 错误或 API 响应
 * @returns {object|null}
 */
export function getStorageQuotaPayload(error) {
  if (!error) return null
  const resData = error.response && error.response.data
  if (resData && isStorageQuotaPayload(resData)) {
    return resData.data && typeof resData.data === 'object' ? resData.data : resData
  }
  if (error.storageQuotaPayload) {
    return error.storageQuotaPayload
  }
  if (isStorageQuotaPayload(error)) {
    return error.data && typeof error.data === 'object' ? error.data : error
  }
  return null
}

/**
 * 空间不足弹窗：提示升级会员
 *
 * @param {string|object} messageOrPayload
 * @param {object|null} routerInstance
 */
export function showStorageQuotaDialog(messageOrPayload, routerInstance) {
  let message = ''
  let upgradePath = '/member/upgrade'

  if (typeof messageOrPayload === 'string') {
    message = messageOrPayload
  } else if (messageOrPayload && typeof messageOrPayload === 'object') {
    const payload = messageOrPayload.data && typeof messageOrPayload.data === 'object'
      ? messageOrPayload.data
      : messageOrPayload
    message = messageOrPayload.message || payload.message || ''
    if (payload.upgradePath) {
      upgradePath = payload.upgradePath
    }
    if (!message && payload.used && payload.total) {
      message = `存储空间不足：已用 ${payload.used} / 总量 ${payload.total}。升级会员可扩容存储空间。`
    }
  }

  if (!message) {
    message = '存储空间不足，无法继续上传。升级会员可扩容存储空间。'
  }

  return MessageBox.confirm(message, '存储空间不足', {
    confirmButtonText: '升级会员',
    cancelButtonText: '知道了',
    type: 'warning',
    distinguishCancelAndClose: true
  }).then(() => {
    const r = routerInstance || router
    if (r && typeof r.push === 'function') {
      r.push(upgradePath)
    }
  }).catch(() => {})
}

/**
 * @param {Error|object} error
 * @param {object|null} routerInstance
 * @returns {boolean} 是否已处理为空间不足
 */
export function handleStorageQuotaError(error, routerInstance) {
  const resData = error && error.response && error.response.data
  const code = resData && typeof resData.code !== 'undefined'
    ? Number(resData.code)
    : (error && error.code)

  if (code !== STORAGE_QUOTA_CODE && !getStorageQuotaPayload(error)) {
    return false
  }

  const payload = getStorageQuotaPayload(error)
  const message = (resData && resData.message) || (error && error.message) || ''
  showStorageQuotaDialog(payload ? { message, ...payload } : message, routerInstance)
  return true
}
